import { combineReducers } from 'redux-immutable';
import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise';

import agent from '../reducers/agent';
import quickReply from '../reducers/quick-reply';
import conversation from '../reducers/conversation';
import enterprise from '../reducers/enterprise';
import visitor from '../reducers/visitor';
import tag from '../reducers/tag';
import call from '../reducers/call';
import productCard from '../reducers/product-card';
import iframePlugin from '../reducers/iframe-plugin';
import convSetting from '../reducers/conv-setting';
import navSetting from '../reducers/nav-setting-BESPOKE';
import marketingStatus from '../reducers/marketing-status';
import func from '../reducers/function';
import channel from '../reducers/channel';
import notification from '../reducers/notification';
import translate from '../reducers/translate';

let store = window._mq_main_store;
if (!store) {
  // 暂时解决多实例问题
  const rootReducer = combineReducers({
    agent,
    quickReply,
    conversationData: conversation,
    enterprise,
    visitor,
    tag,
    call,
    productCard,
    iframePlugin,
    marketingStatus,
    convSetting,
    navSetting,
    func,
    channel,
    notification,
    translate
  });

  const composeEnhancers =
    /* eslint-disable-next-line no-undef */
    typeof window === 'object' && __DEVELOP__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose;

  const middleware = [promiseMiddleware];

  const enhancer = composeEnhancers(
    applyMiddleware(...middleware)
    // other store enhancers if any
  );
  store = window._mq_main_store = createStore(rootReducer, enhancer);
}

export default store;
